var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"mobileDropdown\"> <div class=\"closePopup\"> <p ng-click=\"closePopup()\"><i class=\"fa fa-times\"></i></p> </div> <h6>{{'WIDGET.CODE' | translate}}</h6> <ul class=\"row operators\"> <li class=\"col-xs-12 operator\" ng-repeat=\"operator in config.operators\"> <span class=\"col-xs-12 logo\"><img ng-src=\"./static/mobile-icons/{{operator.icon}}.png\" alt=\"\"></span> <ul class=\"col-xs-12\"> <li class=\"col-xs-4 col-sm-6 code\" ng-repeat=\"code in operator.codes\" ng-click=\"setPhone(operator, code)\">+380{{code}}</li> </ul> </li> </ul> </div>";
ngModule.run(["$templateCache",function(c){c.put("mobileDropdown/templates/mobileDropdown.html",v1)}]);
module.exports=v1;


/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/mobileDropdown/templates/mobileDropdown.html
 ** module id = 55
 ** module chunks = 1
 **/